import React from 'react';
import {
  getSessionStorageField,
  setSessionStorageField,
  samePass
} from './contextHelper';
import {clone} from 'ramda';

const useCart = ({EMPTY_CART_OBJ, authAndContent, account}) => {
  const [cart, setCart] = React.useState(
    getSessionStorageField('cart', clone(EMPTY_CART_OBJ))
  );
  const [showCartIsEmpty, setShowCartIsEmpty] = React.useState(true);
  const [checkout, setCheckout] = React.useState(false);
  const [purchase, setPurchase] = React.useState({
    purchaseConfirmationPage: false,
    cart: clone(EMPTY_CART_OBJ)
  });

  React.useEffect(() => {
    if (!authAndContent.token) {
      setSessionStorageField('cart', null);
      setCart(null);
      clearCartPasses();
    }
  }, [authAndContent.token]);

  React.useEffect(() => {
    const accountBalance =
      account.account?.transitAccounts[0]?.storedValue?.balance;
    const currAccountBalance = accountBalance ? accountBalance : 0;

    setCart(prevCart => ({
      ...prevCart,
      storedValue: currAccountBalance < 0 ? Math.abs(currAccountBalance) : 0
    }));
  }, [account.account]);

  // check if cart should display empty
  React.useEffect(() => {
    if (!authAndContent.token) {
      setSessionStorageField('cart', null);
      return;
    }

    setSessionStorageField('cart', cart);
    if (
      !purchase?.purchaseConfirmationPage &&
      cart?.passes?.length === 0 &&
      cart?.storedValue === 0
    ) {
      return setShowCartIsEmpty(true);
    }
    return setShowCartIsEmpty(false);
  }, [authAndContent.token, cart, setShowCartIsEmpty, purchase.purchaseConfirmationPage]);

  const saveCartPasses = cartPasses => {
    setCart(prevCart => {
      const newCart = {...prevCart, passes: cartPasses};
      setSessionStorageField('cart', newCart);
      return newCart;
    });
  };

  const addToCartPasses = currentPass => {
    const itemExistsInCart = cart.passes.find(pass =>
      samePass(currentPass, pass)
    );
    if (itemExistsInCart) {
      return saveCartPasses(
        cart.passes.map(pass => ({
          ...pass,
          quantity: samePass(pass, currentPass)
            ? pass.quantity + 1
            : pass.quantity
        }))
      );
    }
    return saveCartPasses([...cart.passes, currentPass]);
  };

  const cartPassesSetQuantity = (currentPass, newQuantity) => {
    if (newQuantity === 0) {
      return saveCartPasses(
        cart.passes.filter(pass => !samePass(pass, currentPass))
      );
    }
    return saveCartPasses(
      cart.passes.map(pass => ({
        ...pass,
        ...{
          quantity: samePass(pass, currentPass)
            ? Math.min(2, Math.max(0, newQuantity))
            : pass.quantity
        }
      }))
    );
  };

  const clearCartPasses = () => {
    saveCartPasses([]);
    if (cart?.storedValue === 0) {
      setCheckout(false);
    }
  };

  return {
    cart,
    setCart,
    showCartIsEmpty,
    addToCartPasses,
    cartPassesSetQuantity,
    clearCartPasses,
    checkout,
    setCheckout,
    purchase,
    setPurchase
  };
};

export default useCart;
